const DATE = {
  label: "Date",
  value: "Date",
};

const TEXT = {
  label: "Text",
  value: "Text",
};

const TEXT_OPTIONAL = {
  label: "Text (Optional)",
  value: "Text_Optional",
};

const LANGUAGE = {
  label: "Language",
  value: "Language",
};

const REGION = {
  label: "Region",
  value: "Region",
};

export { DATE, TEXT, TEXT_OPTIONAL, LANGUAGE, REGION };
